import dayjs from 'dayjs'
import { AppointmentModel } from '@devexpress/dx-react-scheduler'

import colors from '@/assets/scss/_themes-vars.module.scss'

import { Consultation } from '@/core/models/consultation.model'
import { MeetingLinkOrder } from '@/core/models/meeting-link-order.model'
import { OrderStatus } from '@/core/models/order.model'

import { redirectTo } from '@/utils/consultations'

import { SchedulerDataType } from '../enums/scheduler-data-type.enum'

const isLive = ['scheduled', 'active', 'accepted']

export function getSchedulerDataFromConsultation(consultation: Consultation): AppointmentModel {
  let color: string | undefined
  switch (consultation.status) {
    case 'accepted':
      color = colors.green400
      break
    case 'refused':
      color = colors.red600
      break
    case 'active':
      color = colors.yellow300
      break
    case 'completed':
      color = colors.orange
      break
    case 'scheduled':
    default:
      break
  }
  return {
    id: consultation._id,
    isLive: isLive.includes(consultation.status),
    title: 'Consultation', // TODO: replace by an appropriate title
    link: redirectTo({
      _id: consultation._id,
      status: consultation.status,
      type: consultation.type,
    }),
    startDate: dayjs(consultation.startDate).toDate(),
    endDate: dayjs(consultation.startDate).add(30, 'minute').toDate(),
    color,
    doctor: consultation.medecin ? `${consultation.medecin.userInfo?.name} ${consultation.medecin.userInfo?.surname}` : ``,
    patient: consultation.patient ? `${consultation.patient.userInfo?.name} ${consultation.patient.userInfo?.surname}` : ``,
    visible: true,
    type: SchedulerDataType.CONSULTATION,
  }
}

export function getSchedulerDataFromOrder(order: MeetingLinkOrder): AppointmentModel {
  let color: string | undefined
  switch (order.status) {
    case OrderStatus.Accepted:
    case OrderStatus.Confirmed:
      color = colors.green400
      break
    case OrderStatus.Pending:
      color = colors.yellow300
      break
    case OrderStatus.Canceled:
    case OrderStatus.No_Show:
      color = '#9e9e9e'
      break
    case OrderStatus.Refused:
      color = colors.red600
      break
    case OrderStatus.In_Progress:
    case OrderStatus.Consultation_Created:
      color = '#42a5f5'
      break
    case OrderStatus.Completed:
      color = colors.orange
      break
    case OrderStatus.Rescheduled:
      color = '#ab47bc'
      break
    default:
      break
  }

  const patientName = order.createdBy
    ? `${order.createdBy.userInfo?.name} ${order.createdBy.userInfo?.surname}`
    : ''

  return {
    id: order._id,
    title: patientName || 'Order',
    startDate: dayjs(order.startDate).toDate(),
    endDate: dayjs(order.startDate).add(30, 'minutes').toDate(),
    color,
    patient: patientName,
    patientId: order.createdBy?._id,
    consultationId: order.consultation?._id,
    speciality: order.speciality,
    meetingPlace: order.meetingPlace?.description,
    meetingPlaceDetails: order.meetingPlace,
    status: order.status,
    visible: true,
    type: SchedulerDataType.ORDER,
  }
}
